const statusProcesso = {
  ANALISE: 'ANALISE',
  EM_ANALISE: 'EM_ANALISE',
  AGUARDANDO_INFORMACAO: 'AGUARDANDO_INFORMACAO',
  AGUARDANDO_ANALISE: 'AGUARDANDO_ANALISE',
  AGUARDANDO_ANALISE_LOTE: 'AGUARDANDO_ANALISE_LOTE',
  AGUARDANDO_ANALISE_ARQUIVAMENTO: 'AGUARDANDO_ANALISE_ARQUIVAMENTO',
  AGUARDANDO_EMISSAO_TITULO: 'AGUARDANDO_EMISSAO_TITULO',
  AGUARDANDO_EMISSAO_CERTIDAO: 'AGUARDANDO_EMISSAO_CERTIDAO',
  AGUARDANDO_BOLETO: 'AGUARDANDO_BOLETO',
  AGUARDANDO_PORTARIA: 'AGUARDANDO_PORTARIA',
  AGUARDANDO_PAGAMENTO: 'AGUARDANDO_PAGAMENTO',
  AGUARDANDO_ENTREGA: 'AGUARDANDO_ENTREGA',
  ENVIADO_PARA_PUBLICACAO: 'ENVIADO_PARA_PUBLICACAO',
  AGUARDANDO_VALIDACAO_ANALISE: 'AGUARDANDO_VALIDACAO_ANALISE',
  AGUARDANDO_PUBLICACAO: 'AGUARDANDO_PUBLICACAO',
  AGUARDANDO_CONFERENCIA_TITULO: 'AGUARDANDO_CONFERENCIA_TITULO',
  EM_CONFERENCIA_TITULO: 'EM_CONFERENCIA_TITULO',
  AGUARDANDO_VALIDACAO_TITULO: 'AGUARDANDO_VALIDACAO_TITULO',
  AGUARDANDO_VALIDACAO_CERTIDAO: 'AGUARDANDO_VALIDACAO_CERTIDAO',
  AGUARDANDO_CONFERENCIA_CERTIDAO: 'AGUARDANDO_CONFERENCIA_CERTIDAO',
  AGUARDANDO_CONFIRMACAO_INTERESSADO: 'AGUARDANDO_CONFIRMACAO_INTERESSADO',
  EM_EMISSAO_CERTIDAO: 'EM_EMISSAO_CERTIDAO',
  EM_EMISSAO_TITULO: 'EM_EMISSAO_TITULO',
  EM_ARQUIVAMENTO: 'EM_ARQUIVAMENTO',
  EM_REVISAO: 'EM_REVISAO',
  EM_REVISAO_PORTARIA: 'EM_REVISAO_PORTARIA',
  VALIDAR: 'VALIDAR',
  PENDENTE: 'PENDENTE',
  ANALISAR_PROCESSO: 'ANALISAR_PROCESSO',
  CONTINUAR_ANALISE: 'CONTINUAR_ANALISE',
  AGUARDANDO_CALCULO_CUSTAS: 'AGUARDANDO_CALCULO_CUSTAS',
  AGUARDANDO_VALIDACAO: 'AGUARDANDO_VALIDACAO',
  AGUARDANDO_DADOS_CUSTA: 'AGUARDANDO_DADOS_CUSTA',
  CADASTRANDO_DADOS_CUSTA: 'CADASTRANDO_DADOS_CUSTA',
  AGUARDANDO_ANALISE_PRELIMINAR: 'AGUARDANDO_ANALISE_PRELIMINAR',
  AGUARDANDO_GERACAO_DOCUMENTOS_AGUARDANDO_VALIDACAO: 'AGUARDANDO_GERACAO_DOCUMENTOS_AGUARDANDO_VALIDACAO',
  AGUARDANDO_CALCULO_VTN: 'AGUARDANDO_CALCULO_VTN',
  EM_CALCULO_VTN: 'EM_CALCULO_VTN',
  AGUARDANDO_ARQUIVAMENTO: 'AGUARDANDO_ARQUIVAMENTO',
  EM_EMISSAO_PORTARIA: 'EM_EMISSAO_PORTARIA',
  AGUARDANDO_PUBLICACAO_PORTARIA: 'AGUARDANDO_PUBLICACAO_PORTARIA',
  EM_PUBLICACAO_PORTARIA: 'EM_PUBLICACAO_PORTARIA',
  AGUARDANDO_ANALISE_TITULO: 'AGUARDANDO_ANALISE_TITULO',
  EM_ANALISE_TITULO: 'EM_ANALISE_TITULO',
  EM_REVISAO_CALCULO_VTN: 'EM_REVISAO_CALCULO_VTN',
  EM_REVISAO_ANALISE_PRELIMINAR: 'EM_REVISAO_ANALISE_PRELIMINAR',
  EM_REVISAO_CADASTRO_DADOS_CUSTA: 'EM_REVISAO_CADASTRO_DADOS_CUSTA',
  AGUARDANDO_ATUALIZACAO_BASE: 'AGUARDANDO_ATUALIZACAO_BASE',
  EM_VALIDACAO_BASE: 'EM_VALIDACAO_BASE',
  AGUARDANDO_REVISAO_BASE: 'AGUARDANDO_REVISAO_BASE',
  EM_ATUALIZACAO_BASE: 'EM_ATUALIZACAO_BASE',
  AGUARDANDO_VALIDACAO_VTN: 'AGUARDANDO_VALIDACAO_VTN',
  AGUARDANDO_VALIDACAO_ANALISE_PRELIMINAR: 'AGUARDANDO_VALIDACAO_ANALISE_PRELIMINAR',
  AGUARDANDO_VALIDACAO_ARQUIVAMENTO: 'AGUARDANDO_VALIDACAO_ARQUIVAMENTO',
  EM_REVISAO_ARQUIVAMENTO: 'EM_REVISAO_ARQUIVAMENTO',
  EM_REVISAO_VALIDACAO: 'EM_REVISAO_VALIDACAO',
  BOLETO_VENCIDO: 'BOLETO_VENCIDO',
  AGUARDANDO_ANALISE_VISTORIA: 'AGUARDANDO_ANALISE_VISTORIA',
  AGUARDANDO_ANALISE_CONSULTOR: 'AGUARDANDO_ANALISE_CONSULTOR',
  EM_ANALISE_VISTORIA: 'EM_ANALISE_VISTORIA',
  EM_ANALISE_DOCUMENTAL: 'EM_ANALISE_DOCUMENTAL',
  AGUARDANDO_ANALISE_DOCUMENTAL: 'AGUARDANDO_ANALISE_DOCUMENTAL',
  AGUARDANDO_ANALISE_DISTRIBUICAO: 'AGUARDANDO_ANALISE_DISTRIBUICAO',
  EM_ANALISE_DISTRIBUICAO: 'EM_ANALISE_DISTRIBUICAO',
  AGUARDANDO_VALIDACAO_DISTRIBUICAO: 'AGUARDANDO_VALIDACAO_DISTRIBUICAO',
  AGUARDANDO_ANALISE_GEO: 'AGUARDANDO_ANALISE_GEO',
  EM_ANALISE_GEO: 'EM_ANALISE_GEO',
  AGUARDANDO_ANALISE_VALIDACAO_GEO: 'AGUARDANDO_ANALISE_VALIDACAO_GEO',
  AGUARDANDO_ANALISE_VERIFICACAO_GEO: 'AGUARDANDO_ANALISE_VERIFICACAO_GEO',
  EM_ANALISE_VALIDACAO_GEO: 'EM_ANALISE_VALIDACAO_GEO',
  AGUARDANDO_VALIDACAO_DOCUMENTAL: 'AGUARDANDO_VALIDACAO_DOCUMENTAL',
  AGUARDANDO_VALIDACAO_VISTORIA: 'AGUARDANDO_VALIDACAO_VISTORIA',
  AGUARDANDO_VALIDACAO_BASE: 'AGUARDANDO_VALIDACAO_BASE',
  EM_REVISAO_BASE: 'EM_REVISAO_BASE',
  AGUARDANDO_VALIDACAO_VALIDACAO_GEO: 'AGUARDANDO_VALIDACAO_VALIDACAO_GEO',
  AGUARDANDO_VALIDACAO_GEO: 'AGUARDANDO_VALIDACAO_GEO',
  EM_REVISAO_DOCUMENTAL: 'EM_REVISAO_DOCUMENTAL',
  EM_REVISAO_GEO: 'EM_REVISAO_GEO',
  EM_REVISAO_VALIDACAO_GEO: 'EM_REVISAO_VALIDACAO_GEO',
  EM_REVISAO_VISTORIA: 'EM_REVISAO_VISTORIA',
  AGUARDANDO_ANALISE_FINAL: 'AGUARDANDO_ANALISE_FINAL',
  EM_ANALISE_FINAL: 'EM_ANALISE_FINAL',
  AGUARDANDO_VALIDACAO_FINAL: 'AGUARDANDO_VALIDACAO_FINAL',
  EM_REVISAO_FINAL: 'EM_REVISAO_FINAL',
  AGUARDANDO_ANALISE_PORTARIA: 'AGUARDANDO_ANALISE_PORTARIA',
  EM_ANALISE_PORTARIA: 'EM_ANALISE_PORTARIA',
  EM_REVISAO_ANALISE_PORTARIA: 'EM_REVISAO_ANALISE_PORTARIA',
  AGUARDANDO_VALIDACAO_PORTARIA: 'AGUARDANDO_VALIDACAO_PORTARIA',
  AGUARDANDO_ENTREGA_TITULO: 'AGUARDANDO_ENTREGA_TITULO',
  EM_ENTREGA_TITULO: 'EM_ENTREGA_TITULO',
  AGUARDANDO_VALIDACAO_ENTREGA_TITULO: 'AGUARDANDO_VALIDACAO_ENTREGA_TITULO',
  EM_REVISAO_ENTREGA_TITULO: 'EM_REVISAO_ENTREGA_TITULO',
  AGUARDANDO_ANALISE_PESQUISA_SPU: 'AGUARDANDO_ANALISE_PESQUISA_SPU',
  EM_ANALISE_PESQUISA_SPU: 'EM_ANALISE_PESQUISA_SPU',
  AGUARDANDO_VALIDACAO_PESQUISA_SPU: 'AGUARDANDO_VALIDACAO_PESQUISA_SPU',
  EM_REVISAO_PESQUISA_SPU: 'EM_REVISAO_PESQUISA_SPU',
  AGUARDANDO_ANALISE_RELATORIO: 'AGUARDANDO_ANALISE_RELATORIO',
  EM_ANALISE_RELATORIO: 'EM_ANALISE_RELATORIO',
  EM_REVISAO_RELATORIO: 'EM_REVISAO_RELATORIO',
  AGUARDANDO_VALIDACAO_RELATORIO: 'AGUARDANDO_VALIDACAO_RELATORIO',
  AGUARDANDO_ANALISE_REUNIAO_MOBILIZACAO: 'AGUARDANDO_ANALISE_REUNIAO_MOBILIZACAO',
  EM_ANALISE_REUNIAO_MOBILIZACAO: 'EM_ANALISE_REUNIAO_MOBILIZACAO',
  AGUARDANDO_ANALISE_PRELIMINAR_GEO: 'AGUARDANDO_ANALISE_PRELIMINAR_GEO',
  EM_ANALISE_PRELIMINAR_GEO: 'EM_ANALISE_PRELIMINAR_GEO',
  EM_REVISAO_PRELIMINAR_GEO: 'EM_REVISAO_PRELIMINAR_GEO',
  AGUARDANDO_VALIDACAO_PRELIMINAR_GEO: 'AGUARDANDO_VALIDACAO_PRELIMINAR_GEO',
  AGUARDANDO_PUBLICACAO_EDITAL: 'AGUARDANDO_PUBLICACAO_EDITAL',
  EM_PUBLICACAO_EDITAL: 'EM_PUBLICACAO_EDITAL',
  EM_REVISAO_PUBLICACAO_EDITAL: 'EM_REVISAO_PUBLICACAO_EDITAL',
  AGUARDANDO_VALIDACAO_PUBLICACAO_EDITAL: 'AGUARDANDO_VALIDACAO_PUBLICACAO_EDITAL',
  AGUARDANDO_ANALISE_PGE: 'AGUARDANDO_ANALISE_PGE',
  EM_ANALISE_PGE: 'EM_ANALISE_PGE',
  EM_REVISAO_ANALISE_PGE: 'EM_REVISAO_ANALISE_PGE',
  AGUARDANDO_DECISAO_FINAL: 'AGUARDANDO_DECISAO_FINAL',
  EM_DECISAO_FINAL: 'EM_DECISAO_FINAL',
  EM_REVISAO_DECISAO_FINAL: 'EM_REVISAO_DECISAO_FINAL',
  AGUARDANDO_VALIDACAO_DECISAO_FINAL: 'AGUARDANDO_VALIDACAO_DECISAO_FINAL',
  AGUARDANDO_VALIDACAO_ANALISE_PGE: 'AGUARDANDO_VALIDACAO_ANALISE_PGE',
  AGUARDANDO_ANALISE_CASA_CIVIL: 'AGUARDANDO_ANALISE_CASA_CIVIL',
  EM_ANALISE_CASA_CIVIL: 'EM_ANALISE_CASA_CIVIL',
  EM_REVISAO_CASA_CIVIL: 'EM_REVISAO_CASA_CIVIL',
  AGUARDANDO_VALIDACAO_CASA_CIVIL: 'AGUARDANDO_VALIDACAO_CASA_CIVIL',
  AGUARDANDO_ANALISE_PDS: 'AGUARDANDO_ANALISE_PDS',
  EM_ANALISE_PDS: 'EM_ANALISE_PDS',
  EM_REVISAO_PDS: 'EM_REVISAO_PDS',
  AGUARDANDO_VALIDACAO_PDS: 'AGUARDANDO_VALIDACAO_PDS',
  AGUARDANDO_ANALISE_INCRA: 'AGUARDANDO_ANALISE_INCRA',
  EM_ANALISE_INCRA: 'EM_ANALISE_INCRA',
  EM_REVISAO_INCRA: 'EM_REVISAO_INCRA',
  AGUARDANDO_VALIDACAO_INCRA: 'AGUARDANDO_VALIDACAO_INCRA',
  AGUARDANDO_ANALISE_GERENCIAMENTO_BENEFICIARIOS: 'AGUARDANDO_ANALISE_GERENCIAMENTO_BENEFICIARIOS',
  EM_ANALISE_GERENCIAMENTO_BENEFICIARIOS: 'EM_ANALISE_GERENCIAMENTO_BENEFICIARIOS',
  EM_REVISAO_GERENCIAMENTO_BENEFICIARIOS: 'EM_REVISAO_GERENCIAMENTO_BENEFICIARIOS',
  AGUARDANDO_VALIDACAO_GERENCIAMENTO_BENEFICIARIOS: 'AGUARDANDO_VALIDACAO_GERENCIAMENTO_BENEFICIARIOS',
  AGUARDANDO_ANALISE_PENDENCIAS: 'AGUARDANDO_ANALISE_PENDENCIAS',
  EM_ANALISE_PENDENCIAS: 'EM_ANALISE_PENDENCIAS',
  AGUARDANDO_VALIDACAO_PENDENCIAS: 'AGUARDANDO_VALIDACAO_PENDENCIAS',
  EM_REVISAO_PENDENCIAS: 'EM_REVISAO_PENDENCIAS',
  AGUARDANDO_ANALISE_GERENCIAMENTO_CREDITOS: 'AGUARDANDO_ANALISE_GERENCIAMENTO_CREDITOS',
  EM_ANALISE_GERENCIAMENTO_CREDITOS: 'EM_ANALISE_GERENCIAMENTO_CREDITOS',
  EM_REVISAO_GERENCIAMENTO_CREDITOS: 'EM_REVISAO_GERENCIAMENTO_CREDITOS',
  AGUARDANDO_VALIDACAO_GERENCIAMENTO_CREDITOS: 'AGUARDANDO_VALIDACAO_GERENCIAMENTO_CREDITOS',
  AGUARDANDO_OS: 'AGUARDANDO_OS',
  AGUARDANDO_ENVIO_CARTORIO: 'AGUARDANDO_ENVIO_CARTORIO',
  EM_RETIFICACAO: 'EM_RETIFICACAO',
  EM_RETIFICACAO_EM_REVISAO: 'EM_RETIFICACAO_EM_REVISAO',
  AGUARDANDO_GERACAO_DOCUMENTOS_EM_ANALISE: 'AGUARDANDO_GERACAO_DOCUMENTOS_EM_ANALISE',
  AGUARDANDO_GERACAO_DOCUMENTOS_AGUARDANDO_OS: 'AGUARDANDO_GERACAO_DOCUMENTOS_AGUARDANDO_OS',
  AGUARDANDO_GERACAO_DOCUMENTOS_AGUARDANDO_ANALISE: 'AGUARDANDO_GERACAO_DOCUMENTOS_AGUARDANDO_ANALISE',
  AGUARDANDO_GERACAO_DOCUMENTOS: 'AGUARDANDO_GERACAO_DOCUMENTOS',
  AGUARDANDO_DECISAO: 'AGUARDANDO_DECISAO',
  AGUARDANDO_EMISSAO_OFICIO: 'AGUARDANDO_EMISSAO_OFICIO',
  EM_EMISSAO_OFICIO: 'EM_EMISSAO_OFICIO',
  EM_REVISAO_OFICIO: 'EM_REVISAO_OFICIO',
  AGUARDANDO_VALIDACAO_OFICIO: 'AGUARDANDO_VALIDACAO_OFICIO',
  AGUARDANDO_CONSULTA_OUTORGA: 'AGUARDANDO_CONSULTA_OUTORGA',
  EM_CONSULTA_OUTORGA: 'EM_CONSULTA_OUTORGA',
  AGUARDANDO_CONSULTA_SNCR: 'AGUARDANDO_CONSULTA_SNCR',
  EM_CONSULTA_SNCR: 'EM_CONSULTA_SNCR',
  EM_RETIFICACAO_EM_EMISSAO_TITULO: 'EM_RETIFICACAO_EM_EMISSAO_TITULO',
  CONTINUAR_EMISSAO: 'CONTINUAR_EMISSAO',
  AGUARDANDO_DISPONIBILIDADE_TITULO: 'AGUARDANDO_DISPONIBILIDADE_TITULO',
  EM_DECISAO: 'EM_DECISAO',
  AGUARDANDO_ANALISE_DRF: 'AGUARDANDO_ANALISE_DRF',
  EM_ANALISE_DRF: 'EM_ANALISE_DRF',
  AGUARDANDO_VALIDACAO_DRF: 'AGUARDANDO_VALIDACAO_DRF',
  EM_REVISAO_DRF: 'EM_REVISAO_DRF',
  PROCESSO_DEFERIDO: 'PROCESSO_DEFERIDO',
  AGUARDANDO_DOCUMENTOS_INTERESSADO: 'AGUARDANDO_DOCUMENTOS_INTERESSADO',
  AGUARDANDO_VALIDACAO_DOCUMENTOS: 'AGUARDANDO_VALIDACAO_DOCUMENTOS',
  EM_ANALISE_DADOS_CADASTRO: 'EM_ANALISE_DADOS_CADASTRO',
  AGUARDANDO_ANALISE_URBANISTICO: 'AGUARDANDO_ANALISE_URBANISTICO',
  EM_ANALISE_URBANISTICO: 'EM_ANALISE_URBANISTICO',
  AGUARDANDO_VALIDACAO_URBANISTICO: 'AGUARDANDO_VALIDACAO_URBANISTICO',
  EM_REVISAO_URBANISTICO: 'EM_REVISAO_URBANISTICO',
  EM_FINALIZACAO: 'EM_FINALIZACAO',
  AGUARDANDO_FINALIZACAO: 'AGUARDANDO_FINALIZACAO',
  EM_REVISAO_FINALIZACAO: 'EM_REVISAO_FINALIZACAO',
  AGUARDANDO_ANALISE_RESPOSTA_SPU: 'AGUARDANDO_ANALISE_RESPOSTA_SPU',
  AGUARDANDO_VALIDACAO_RESPOSTA_SPU: 'AGUARDANDO_VALIDACAO_RESPOSTA_SPU',
  EM_REVISAO_RESPOSTA_SPU: 'EM_REVISAO_RESPOSTA_SPU',
  EM_ANALISE_RESPOSTA_SPU: 'EM_ANALISE_RESPOSTA_SPU',
  AGUARDANDO_IMPRESSAO_TITULO: 'AGUARDANDO_IMPRESSAO_TITULO',
  AGUARDANDO_ASSINATURA: 'AGUARDANDO_ASSINATURA',
  AGUARDANDO_ANALISE_MALHA_FUNDIARIA: 'AGUARDANDO_ANALISE_MALHA_FUNDIARIA',
  EM_ANALISE_MALHA_FUNDIARIA: 'EM_ANALISE_MALHA_FUNDIARIA',
  AGUARDANDO_EMISSAO_PORTARIA: 'AGUARDANDO_EMISSAO_PORTARIA',
  AGUARDANDO_ANALISE_LAUDO_VISTORIA: 'AGUARDANDO_ANALISE_LAUDO_VISTORIA',
  AGUARDANDO_ANALISE_AUTOMATIZADA: 'AGUARDANDO_ANALISE_AUTOMATIZADA',
  BOLETO: 'BOLETO',
  REGERANDO_ANALISE_AUTOMATIZADA: 'REGERANDO_ANALISE_AUTOMATIZADA',
  REGERANDO_ANALISE_AUTOMATIZADA_LOTE: 'REGERANDO_ANALISE_AUTOMATIZADA_LOTE',
  REGERANDO_ANALISE_AUTOMATIZADA_ANALISE_LOTE: 'REGERANDO_ANALISE_AUTOMATIZADA_ANALISE_LOTE',
  AGUARDANDO_EMISSAO_CERTIDAO_AREA: 'AGUARDANDO_EMISSAO_CERTIDAO_AREA',
  EM_EMISSAO_CERTIDAO_AREA: 'EM_EMISSAO_CERTIDAO_AREA',
  AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA: 'AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA',
  AGUARDANDO_EMISSAO_EXTRATO_SENTENCA: 'AGUARDANDO_EMISSAO_EXTRATO_SENTENCA',
  EM_EMISSAO_EXTRATO_SENTENCA: 'EM_EMISSAO_EXTRATO_SENTENCA',
  EM_ARQUIVAMENTO_INDEFERIMENTO: 'EM_ARQUIVAMENTO_INDEFERIMENTO',
  AGUARDANDO_ARQUIVAMENTO_INDEFERIMENTO: 'AGUARDANDO_ARQUIVAMENTO_INDEFERIMENTO',
  AGUARDANDO_VALIDACAO_ARQUIVAMENTO_INDEFERIMENTO: 'AGUARDANDO_VALIDACAO_ARQUIVAMENTO_INDEFERIMENTO',
  EM_REVISAO_ARQUIVAMENTO_INDEFERIMENTO: 'EM_REVISAO_ARQUIVAMENTO_INDEFERIMENTO',
  EM_ANALISE_INDEFERIMENTO: 'EM_ANALISE_INDEFERIMENTO',
  AGUARDANDO_ANALISE_INDEFERIMENTO: 'AGUARDANDO_ANALISE_INDEFERIMENTO',
  AGUARDANDO_VALIDACAO_INDEFERIMENTO: 'AGUARDANDO_VALIDACAO_INDEFERIMENTO',
  FINALIZADO: 'FINALIZADO',
  AGUARDANDO_ELABORACAO_ERRATA_TITULO: 'AGUARDANDO_ELABORACAO_ERRATA_TITULO',
  EM_ELABORACAO_ERRATA_TITULO: 'EM_ELABORACAO_ERRATA_TITULO',
  AGUARDANDO_ASSINATURA_ERRATA_TITULO: 'AGUARDANDO_ASSINATURA_ERRATA_TITULO',
  AGUARDANDO_IMPRESSAO_ERRATA_TITULO: 'AGUARDANDO_IMPRESSAO_ERRATA_TITULO',
  EM_ANALISE_PARECER_INDEFERIMENTO: 'EM_ANALISE_PARECER_INDEFERIMENTO',
  AGUARDANDO_PARECER_INDEFERIMENTO: 'AGUARDANDO_PARECER_INDEFERIMENTO',
  AGUARDANDO_VALIDACAO_PARECER_INDEFERIMENTO: 'AGUARDANDO_VALIDACAO_PARECER_INDEFERIMENTO',
  EM_REVISAO_INDEFERIMENTO: 'EM_REVISAO_INDEFERIMENTO',
  AGUARDANDO_ANALISE_DESARQUIVAMENTO: 'AGUARDANDO_ANALISE_DESARQUIVAMENTO',
  EM_ANALISE_DESARQUIVAMENTO: 'EM_ANALISE_DESARQUIVAMENTO',
  AGUARDANDO_VALIDACAO_DESARQUIVAMENTO: 'AGUARDANDO_VALIDACAO_DESARQUIVAMENTO',
  EM_REVISAO_DESARQUIVAMENTO: 'EM_REVISAO_DESARQUIVAMENTO',
  AGUARDANDO_PARECER_DESARQUIVAMENTO: 'AGUARDANDO_PARECER_DESARQUIVAMENTO',
  EM_ANALISE_PARECER_DESARQUIVAMENTO: 'EM_ANALISE_PARECER_DESARQUIVAMENTO',
  AGUARDANDO_VALIDACAO_PARECER_DESARQUIVAMENTO: 'AGUARDANDO_VALIDACAO_PARECER_DESARQUIVAMENTO',
  EM_REVISAO_PARECER_DESARQUIVAMENTO: 'EM_REVISAO_PARECER_DESARQUIVAMENTO',
  AGUARDANDO_ANALISE_FINALIZACAO: 'AGUARDANDO_ANALISE_FINALIZACAO',
  EM_ANALISE_FINALIZACAO: 'EM_ANALISE_FINALIZACAO',
  AGUARDANDO_APROVACAO: 'AGUARDANDO_APROVACAO',
  AGUARDANDO_PARECER_FINAL: 'AGUARDANDO_PARECER_FINAL',
  EM_ANALISE_PARECER_FINAL: 'EM_ANALISE_PARECER_FINAL',
  TITULO_COM_ERRATA: 'TITULO_COM_ERRATA',
  ARQUIVADO: 'ARQUIVADO',
  AGUARDANDO_SUSPENSAO: 'AGUARDANDO_SUSPENSAO',
  SUSPENSO: 'SUSPENSO',
  TITULO_CANCELADO: 'TITULO_CANCELADO'
}

export default statusProcesso



// WEBPACK FOOTER //
// ./src/utils/status.js